import { render, staticRenderFns } from "./testQuestion.vue?vue&type=template&id=3a76b1ee&scoped=true&"
import script from "./testQuestion.vue?vue&type=script&lang=js&"
export * from "./testQuestion.vue?vue&type=script&lang=js&"
import style0 from "./testQuestion.vue?vue&type=style&index=0&id=3a76b1ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a76b1ee",
  null
  
)

export default component.exports